import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import TrustedBySection from "@/components/TrustedBySection";
import HowItWorksSection from "@/components/HowItWorksSection";
import FeaturesSection from "@/components/FeaturesSection";
import IntegrationsSection from "@/components/IntegrationsSection";
import UseCasesSection from "@/components/UseCasesSection";
import TestimonialsSection from "@/components/TestimonialsSection";
import PricingSection from "@/components/PricingSection";
import ComparisonSection from "@/components/ComparisonSection";
import GuaranteesSection from "@/components/GuaranteesSection";
import FAQSection from "@/components/FAQSection";
import CTASection from "@/components/CTASection";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main role="main" aria-label="Conteúdo principal">
        <article>
          <HeroSection />
          <TrustedBySection />
          <HowItWorksSection />
          <FeaturesSection />
          <IntegrationsSection />
          <UseCasesSection />
          <TestimonialsSection />
          <PricingSection />
          <ComparisonSection />
          <GuaranteesSection />
          <FAQSection />
          <CTASection />
        </article>
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default Index;
